var React = require('react');

function ContactFlag2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m-6 36h258.111321l84.888679 134h-343z","fill":"#4eb684","fillRule":"evenodd","opacity":".05","transform":"matrix(-1 0 0 1 337 -36)"}));
}

ContactFlag2.defaultProps = {"height":"134","viewBox":"0 0 337 134","width":"337"};

module.exports = ContactFlag2;

ContactFlag2.default = ContactFlag2;
